import {
	Button,
	H1,
	HStack,
	IconLayers,
	Link,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { SystemEntity } from 'domain/systemEntity/interfaces/SystemEntity';
import { FunctionComponent } from 'react';
import useAuthRoles from 'hooks/useAuthRoles';
import { AdminRole } from 'domain/account/enums/AdminRole';

const SystemEntityDetails: FunctionComponent<{
	systemEntity: SystemEntity;
	setIsEditing: (isEditing: boolean) => void;
}> = ({ systemEntity, setIsEditing }) => {
	const { adminIsRestrictedToRole: isRestrictedToRole } = useAuthRoles();

	return (
		<VStack gap="xl" fullWidth>
			<HStack align="center" gap="md" justify="space-between" fullWidth>
				<HStack align="center" gap="md">
					<IconLayers boxSize="1.5rem" />
					<H1>{systemEntity.displayName}</H1>
				</HStack>
				<Button
					text={'Edit info'}
					isDisabled={isRestrictedToRole(AdminRole.SALES)}
					onClick={() => {
						setIsEditing(true);
					}}
				/>
			</HStack>
			<HStack fullWidth gap="xl">
				<LabelAndValue
					minWidth="30%"
					label="Company"
					value={
						<HStack align="center">
							{systemEntity.companyId ? (
								<Link
									href={
										'/companies/' + systemEntity.companyId
									}
								>
									{systemEntity.companyName}
								</Link>
							) : (
								<Text fontStyle="italic" color="textDisabled">
									- no company connection
								</Text>
							)}
						</HStack>
					}
				/>
			</HStack>
		</VStack>
	);
};

export default SystemEntityDetails;
